<script lang="ts">
  import LongTermGoalSetup from "./LongTermGoalSetup.svelte"
  import AnnualGoalSetup from "./AnnualGoalSetup.svelte"
  import QuarterlyGoalSetup from "./QuarterlyGoalSetup.svelte"
  import GoalReview from "./GoalReview.svelte"
  import TaskSetup from "./TaskSetup.svelte"
  import Finish from "./Finish.svelte"
  import { appStore } from "$app/store.svelte"

  let { rootGoalId } = $props()
</script>

{#if appStore.onboarding.current_onboarding_step === "long_term_goal" || appStore.onboarding.current_onboarding_step === "goal_overview"}
  <div class="bg-gray-600 rounded p-6 mt-6 border-l-4 border-long-term-goal">
    <LongTermGoalSetup {rootGoalId} />
  </div>
{:else if appStore.onboarding.current_onboarding_step === "annual_goal"}
  <div class="bg-gray-600 rounded p-6 mt-6 border-l-4 border-annual-goal">
    <AnnualGoalSetup />
  </div>
{:else if appStore.onboarding.current_onboarding_step === "quarterly_goal"}
  <div class="bg-gray-600 rounded p-6 mt-6 border-l-4 border-quarterly-goal">
    <QuarterlyGoalSetup />
  </div>
{:else if appStore.onboarding.current_onboarding_step === "task"}
  <div class="bg-gray-600 rounded p-6 mt-6 border-l-4 border-task">
    <TaskSetup />
  </div>
{:else if appStore.onboarding.current_onboarding_step === "goal_review"}
  <div class="bg-gray-600 rounded p-6 mt-6">
    <GoalReview />
  </div>
{:else if appStore.onboarding.current_onboarding_step === "review"}
  <div class="bg-gray-600 rounded p-6 mt-6">
    <Finish />
  </div>
{:else}
  <p class="text-lg text-center mt-6 text-gray-700">
    The Goals page will be available once you have completed the setup process.
  </p>
{/if}
